import ru from 'moment/locale/ru';
import moment from 'moment';
import { DateObject } from 'react-multi-date-picker';

moment.updateLocale('ru', ru);

export default function getDefaultDataRange(count = 1, type = 'months', format = 'YYYY-MM-DD') {
  const today = moment();
  const subtract = today.clone()
    .startOf('day')
    .subtract(count, type);
  return [subtract.format(format), today.clone().endOf('day').format(format)];
}
